import React, { Component } from "react";
import { Icon, Modal, Menu, Label, Tab, Dropdown } from "semantic-ui-react";
import moment from "moment";
import { app } from "../..";
import { createservice } from "../../services/crudservice";
import MsgList from "./messagelist";
import "./msgs.css";
import SendMsg from "./sendmessage";
class Messaging extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: {
        importance: "M",
        senddate: moment().format("YYYY-MM-DD"),
        toemp: null,
        tocustomer: "",
        subject: "",
        readind: 0,
        deleted: 0
      },
      messageindex: 0,
      modalindex: 0,
      msgtabs: []
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.showModal === false && this.props.showModal) {
      this.handleackalert();
    }
  }

  handleread(idarray) {
    console.log("nope");
    if (idarray) {
      app.service("messages").patch(
        null,
        { readind: 1 },
        {
          query: {
            id: {
              $in: idarray
            }
          }
        }
      );
    }
  }
  handleackalert() {
    console.log("nope");
    if (this.props.myinfo) {
      app.service("messages").patch(
        null,
        { readind: 1 },
        {
          query: { toemp: this.props.myinfo.empnumber, importance: "A" }
        }
      );
    }
  }
  sortmessages(msgs) {
    return msgs.sort((a, b) => a.emp.empnumber - b.emp.empnumber);
  }

  genmsgtabs() {
    var messages = [];
    var employees;
    if (this.props.employees) {
      employees = this.props.employees.map(emp => {
        return {
          key: emp.empnumber,
          text: emp.firstname + " " + emp.lastname,
          value: emp
        };
      });
    }

    var messagetabs = [];
    if (this.props.messages && this.props.messages.length) {
      messages = this.sortmessages(this.props.messages);
      messagetabs = this.props.messages.map((msgtab, index) => {
        console.log(msgtab.emp);
        return {
          menuItem: (
            <Menu.Item key={msgtab.emp.empnumber}>
              {msgtab.emp.firstname}
              {msgtab.unreadcount ? (
                <Label>{msgtab.unreadcount}</Label>
              ) : (
                <div />
              )}
            </Menu.Item>
          ),
          render: () => (
            <div>
              <MsgList
                msgindex={index}
                myempnumber={this.props.myinfo.empnumber}
                messages={msgtab.messages}
                emp={msgtab.emp}
                message
                messageindex={this.state.messageindex}
                markread={idarray => this.handleread(idarray)}
              />
              <SendMsg
                tabinfo={msgtab}
                Send={message => {
                  let Message = {
                    ...this.state.msg,
                    fromemp: this.props.myinfo.empnumber,
                    tocustomer: null,
                    message,
                    toemp: msgtab.emp.empnumber
                  };
                  app
                    .service("messages")
                    .create(Message)
                    .then(response => console.log(response));
                }}
              />
            </div>
          )
        };
      });
    }
    messagetabs = messagetabs.concat({
      menuItem: (
        <Menu.Item key={0} color="blue">
          <span>
            <Icon name="plus" />
            <Icon name="mail outline" />
            New Message
          </span>
        </Menu.Item>
      ),
      render: () => (
        <div>
          <Dropdown
            search
            fluid
            selection
            placeholder={"Select Employee"}
            options={employees}
            onChange={(e, { value }) => {
              this.setState({ newmsgemp: value });
            }}
          />

          <SendMsg
            Send={message => {
              let Message = {
                ...this.state.msg,
                fromemp: this.props.myinfo.empnumber,
                tocustomer: null,
                message,
                toemp: this.state.newmsgemp.empnumber
              };
              createservice("messages", Message);
            }}
          />
        </div>
      )
    });
    return messagetabs;
  }
  AlertsTable() {
    if (this.props.alerts.length) {
      return <MsgList messages={this.props.alerts} alert />;
    } else {
      return <p>No Alerts for you ...</p>;
    }
  }
  handleChange = (e, data) => console.log(data);

  Messages() {
    let panes = this.genmsgtabs();
    var msg_index;
    if (
      this.state.newmsgemp &&
      this.state.newmsgemp.empnumber &&
      this.props.messages
    ) {
      msg_index = this.props.messages.findIndex(
        m => m.emp.empnumber === this.state.newmsgemp.empnumber
      );
      msg_index = msg_index > -1 ? msg_index : this.state.messageindex;
    } else {
      msg_index = this.state.messageindex;
    }
    return (
      <Tab
        onTabChange={(e, { activeIndex }) => {
          console.log("Msg Tab changed", activeIndex);
          this.setState({ messageindex: activeIndex, newmsgemp: null });
        }}
        activeIndex={msg_index}
        menu={{ fluid: true, vertical: true, tabular: "left" }}
        panes={panes}
      />
    );
  }
  render() {
    const panes = [
      {
        menuItem: "Alerts",
        render: () => <div>{this.AlertsTable()}</div>
      },
      {
        menuItem: "Messages",
        render: () => <div>{this.Messages()}</div>
      }
    ];
    return (
      <Modal
        size="large"
        open={this.props.showModal}
        onClose={() => this.props.handleclose()}
      >
        <Modal.Header>Alerts / Messages</Modal.Header>

        <Modal.Content>
          <Tab
            menu={{ secondary: true, pointing: true }}
            panes={panes}
            onTabChange={(e, { activeIndex }) => {
              this.setState({ modalindex: activeIndex });
            }}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export default Messaging;



// WEBPACK FOOTER //
// ./src/components/messaging/messagingmodal.js